<script setup lang="ts">
/**
 * The sprout — the mark for the focus **capability** itself.
 *
 * Distinct from the stage trees (`components/focus-stages/`), which are
 * attainment rungs *within* focus. This glyph is stage-independent: it appears
 * on the focus-goal block, the Focus pill, and the boot loader, and it never
 * grows leaves to signal progress (that is the trees' job — see
 * `ADDENDUM-focus-stages.md` §6).
 *
 * Drawn in `currentColor` so it works on a near-black CTA, a mint pill and a
 * plain surface without per-context overrides. Stroke weight matches the
 * Lucide set it sits beside.
 */
withDefaults(defineProps<{ size?: number }>(), { size: 16 });
</script>

<template>
  <svg
    :width="size"
    :height="size"
    viewBox="0 0 24 24"
    fill="none"
    aria-hidden="true"
    focusable="false"
  >
    <path
      d="M12 21V10"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path d="M12 13C8.7 13 6 10.3 6 7c3.3 0 6 2.7 6 6z" fill="currentColor" />
    <path d="M12 11c0-3.3 2.7-6 6-6 0 3.3-2.7 6-6 6z" fill="currentColor" />
  </svg>
</template>
